/**
 * Splits a semicolon-separated string into trimmed, non-empty entries.
 *
 * Cross #8 SI3 (2026-05-10): separator changed from comma (`,`) to
 * semicolon (`;`) to preserve commas inside individual entries — e.g.
 * decimal numbers like "2,5 Jahre" or comma-bearing descriptions like
 * "Noelle (Rubens 2,5 Jahre jüngere Schwester)". Pre-Check 2026-05-10
 * confirmed all 3 caller-site form fields (interests / bezugspersonen /
 * orte) use single-line `<Input type="text">`, so newline support is
 * not needed.
 *
 * Function name `splitCSV` preserved to avoid caller-site churn — "CSV"
 * is now mildly inaccurate (semicolon-separated, not comma-separated)
 * but renaming would be unnecessary blast radius.
 */
export function splitCSV(raw: string): string[] {
  return raw
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean);
}
